import { ProtocolIcon } from './chunk-YCHCINMX.js';
import { ProtocolBadge } from './chunk-O26G5KPD.js';
import { PANCAKESWAP_V3_POOL, PANCAKESWAP_V3_POOL_COMPONENTS, PANCAKESWAP_V3_POOL_EVENTS, pickField, PANCAKESWAP_V3_POOL_FIELDS, PANCAKESWAP_V3_POOL_LABELS, ProtocolValue, SectionCard, FactGrid, ProtocolParamList } from './chunk-NNFGQV3X.js';
import { ArrowLeftRight } from 'lucide-react';
import { jsx, jsxs } from 'react/jsx-runtime';

function side(value) {
  if (value == null) return void 0;
  const text = String(value).trim();
  if (!/^-?\d+$/.test(text)) return void 0;
  const negative = text.startsWith("-");
  const magnitude = negative ? text.slice(1) : text;
  if (/^0+$/.test(magnitude)) return void 0;
  return { magnitude, negative };
}
function PancakeSwapPoolSwap({
  event: event2,
  hint,
  chain,
  renderAddress
}) {
  const pid = hint.protocolId ?? PANCAKESWAP_V3_POOL.protocolId;
  const sender = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.sender);
  const recipient = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.recipient);
  const zero = side(pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.amount0));
  const one = side(pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.amount1));
  const fee0 = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.protocolFeesToken0);
  const fee1 = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.protocolFeesToken1);
  const tick = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.tick);
  const liquidity = pickField(event2.params, PANCAKESWAP_V3_POOL_FIELDS.liquidity);
  const address = (value) => typeof value === "string" && renderAddress ? renderAddress(value, { chain }) : /* @__PURE__ */ jsx(ProtocolValue, { value });
  const facts = [
    // The emitter IS the venue — on a direct trade it is the only contract in
    // the transaction anybody can name.
    { label: PANCAKESWAP_V3_POOL_LABELS.pool, value: address(event2.address), when: event2.address },
    { label: PANCAKESWAP_V3_POOL_LABELS.trader, value: address(sender), when: sender },
    { label: PANCAKESWAP_V3_POOL_LABELS.recipient, value: address(recipient), when: recipient },
    // Positive = into the pool = the trader sold it. Negative = out = bought.
    {
      label: PANCAKESWAP_V3_POOL_LABELS.soldToken0,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: zero?.magnitude }),
      when: zero && !zero.negative
    },
    {
      label: PANCAKESWAP_V3_POOL_LABELS.boughtToken0,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: zero?.magnitude }),
      when: zero && zero.negative
    },
    {
      label: PANCAKESWAP_V3_POOL_LABELS.soldToken1,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: one?.magnitude }),
      when: one && !one.negative
    },
    {
      label: PANCAKESWAP_V3_POOL_LABELS.boughtToken1,
      value: /* @__PURE__ */ jsx(ProtocolValue, { value: one?.magnitude }),
      when: one && one.negative
    },
    { label: PANCAKESWAP_V3_POOL_LABELS.tick, value: /* @__PURE__ */ jsx(ProtocolValue, { value: tick }), when: tick != null },
    { label: PANCAKESWAP_V3_POOL_LABELS.liquidity, value: /* @__PURE__ */ jsx(ProtocolValue, { value: liquidity }), when: liquidity != null }
  ];
  return /* @__PURE__ */ jsxs(
    SectionCard,
    {
      title: /* @__PURE__ */ jsxs("span", { className: "inline-flex items-center gap-2", children: [
        /* @__PURE__ */ jsx(ProtocolIcon, { protocolId: pid, icon: ArrowLeftRight }),
        /* @__PURE__ */ jsx("span", { className: "text-sm font-semibold", children: hint.label ?? "Swap on PancakeSwap V3" })
      ] }),
      protocolId: pid,
      meta: /* @__PURE__ */ jsx(ProtocolBadge, { protocolId: pid }),
      children: [
        /* @__PURE__ */ jsx(FactGrid, { facts }),
        /* @__PURE__ */ jsxs("details", { className: "mt-3 min-w-0", children: [
          /* @__PURE__ */ jsxs("summary", { className: "cursor-pointer text-xs text-muted-foreground hover:text-foreground", children: [
            "All event fields",
            (fee0 != null || fee1 != null) && ` (incl. ${PANCAKESWAP_V3_POOL_LABELS.protocolFees.toLowerCase()})`
          ] }),
          /* @__PURE__ */ jsx("div", { className: "pt-2", children: /* @__PURE__ */ jsx(ProtocolParamList, { params: event2.params, emptyLabel: "No decoded fields" }) })
        ] })
      ]
    }
  );
}

// src/protocols/pancakeswap_v3_pool/index.ts
var PID = PANCAKESWAP_V3_POOL.protocolId;
var C = PANCAKESWAP_V3_POOL_COMPONENTS;
var event = (name, component) => ({
  protocolId: PID,
  event: name,
  component,
  summaryFields: []
});
var PANCAKESWAP_V3_POOL_HINTS = {
  valueHints: [],
  callHints: [],
  eventHints: [event(PANCAKESWAP_V3_POOL_EVENTS.swap, C.poolSwap)]
};
function registerPancakeSwapV3Pool(registry) {
  registry.registerEvent(C.poolSwap, PancakeSwapPoolSwap);
  registry.registerHints(PANCAKESWAP_V3_POOL_HINTS);
  return registry;
}

export { PANCAKESWAP_V3_POOL_HINTS, PancakeSwapPoolSwap, registerPancakeSwapV3Pool };
//# sourceMappingURL=chunk-QLGZFVLK.js.map
//# sourceMappingURL=chunk-QLGZFVLK.js.map